import { createReducer, on } from '@ngrx/store';

import { ProfileModuleState } from '../../models/profile.model';
import * as profileActions from '../actions/profile.actions';

export const profileReducer = createReducer<ProfileModuleState>(
  {} as ProfileModuleState,

  on(profileActions.autoSuggestProfilesSuccess, (state, { autoSuggest }) => ({
    ...state,
    autoSuggest,
  })),

  on(profileActions.searchProfilesSuccess, (state, { profile }) => ({
    ...state,
    profile,
    loadResult: true,
  })),

  on(profileActions.b2cProfileNotFound, (state, { profile }) => ({
    ...state,
    b2cProfile: profile,
  })),

  on(profileActions.setApplications, (state, { applications }) => ({
    ...state,
    applications: applications
      .concat()
      .sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0)),
  })),

  on(profileActions.setApplicationGroups, (state, { applicationGroups }) => ({
    ...state,
    applicationGroups: applicationGroups
      .concat()
      .sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0)),
  })),

  on(profileActions.setAccessRules, (state, { accessRules }) => ({
    ...state,
    accessRules,
  })),

  on(profileActions.setRoles, (state, { roles }) => ({
    ...state,
    roles: roles
      .concat()
      .sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0)),
  })),

  on(profileActions.searchProfileNotFound, (state) => ({
    ...state,
    loadResult: false,
  })),

  on(profileActions.clearProfileResult, (state) => ({
    ...state,
    profileModule: {},
  })),
);
